import { cn } from "@/lib/utils"

/**
 * A scrollable tab strip that never grows a scrollbar. The classic tab
 * markup (container border-b + buttons with -mb-px overlapping it) overflows
 * a scroll container by exactly 1px, which macOS renders as a permanent
 * scrollbar. Here the hairline is painted BEHIND the buttons (absolute at
 * the bottom) so buttons need no negative margin — the active tab's accent
 * border covers the hairline pixel-for-pixel — and the scrollbar is hidden
 * on both engines; horizontal scrolling still works by gesture on narrow
 * screens. Buttons keep the usual classes minus `-mb-px`.
 */
export function TabStrip({
  children,
  className,
  testid,
}: {
  children: React.ReactNode
  className?: string
  testid?: string
}) {
  return (
    <div className={cn("relative", className)} data-testid={testid}>
      <div aria-hidden className="absolute inset-x-0 bottom-0 h-px bg-hairline" />
      <div className="relative flex gap-6 overflow-x-auto text-sm [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {children}
      </div>
    </div>
  )
}
